import { useQueryClient } from '@tanstack/react-query';
import { ProviderActivationEventName } from '@uplift/api';
import { providerQueryKeys, useAddProviderActivationEventMutation } from '@uplift/queries';

export const useOnboardingEventActions = (providerId: string) => {
  const queryClient = useQueryClient();
  const addEventMutation = useAddProviderActivationEventMutation();

  const dispatchOnboardingEvent = async (eventName: ProviderActivationEventName, providerId: string) => {
    await addEventMutation.mutateAsync({ providerId, eventName });
    await queryClient.invalidateQueries({ queryKey: providerQueryKeys.statesSelection(providerId) });
  };

  return {
    welcomeVideoWatched: async () => dispatchOnboardingEvent(ProviderActivationEventName.introductionVideoCompleted, providerId),
    matchingAvailabilitySubmitted: async () => dispatchOnboardingEvent(ProviderActivationEventName.matchingAvailabilitySubmitted, providerId),
    matchingAvailabilityApproved: async () => dispatchOnboardingEvent(ProviderActivationEventName.matchingAvailabilityApproved, providerId),
    confettiDisplayed: async () => dispatchOnboardingEvent(ProviderActivationEventName.confettiDisplayed, providerId),
    stateSelectionSubmitted: async () => dispatchOnboardingEvent(ProviderActivationEventName.stateSelectionSubmitted, providerId),
  };
};
